module.exports = __webpack_public_path__ + "static/videoSection-1570b44bb79bc194f65acf198dd2a9d7.png";